import { render, staticRenderFns } from "./AuditRecord.vue?vue&type=template&id=31d5e8b2&"
import script from "./AuditRecord.vue?vue&type=script&lang=js&"
export * from "./AuditRecord.vue?vue&type=script&lang=js&"
import style0 from "./AuditRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports